import { render, staticRenderFns } from "./mensageria-form.vue?vue&type=template&id=1185e28a"
import script from "./mensageria-form.vue?vue&type=script&lang=js"
export * from "./mensageria-form.vue?vue&type=script&lang=js"
import style0 from "./mensageria-form.vue?vue&type=style&index=0&id=1185e28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports